import { AppBar as AppBarComponent } from 'components'
import { useAuthContext } from 'hooks/useAuthContext'
import { useSearchState } from 'hooks/useSearch'
import { translateRoute } from 'i18n/helpers'
import { IBreadcrumbItem } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useRoute } from 'react-router5'
import { generateRouteBreadcrumbs } from './generateRouteBreadcrumbs'

export const AppBar: React.FunctionComponent = () => {
  const { route, router } = useRoute()
  const { t } = useTranslation()
  const auth = useAuthContext()
  const search = useSearchState()

  const breadcrumbItems: IBreadcrumbItem[] = generateRouteBreadcrumbs(
    route
  ).map(
    ({ route: breadcrumbRoute, ...breadcrumb }) =>
      ({
        ...breadcrumb,
        text: breadcrumb.text || translateRoute(breadcrumb.key, t),
        onClick: () =>
          router.navigate(breadcrumbRoute.name, breadcrumbRoute.params),
      } as IBreadcrumbItem)
  )

  return (
    <AppBarComponent
      searchProps={search.active ? search.props : undefined}
      breadcrumbItems={breadcrumbItems}
      person={auth ? auth.user : undefined}
    />
  )
}
